import { useEffect } from 'react';
import { createPumpGatewayClient } from '../utils/backend/session';

const pumpSocket = createPumpGatewayClient(process.env.REACT_APP_BACKEND_URL!, process.env.REACT_APP_BACKEND_APIKEY!);

export const usePumpGateway = () => {
    useEffect(() => {
        pumpSocket.on('connect', () => console.debug('[PumpGateway] Connected', pumpSocket.id));
        pumpSocket.on('connect_error', () => console.debug('[PumpGateway] Connection error'));
        pumpSocket.on('disconnect', () => console.debug('[PumpGateway] Disconnected'));

        pumpSocket.connect();

        return () => {
            pumpSocket.off('connect');
            pumpSocket.off('connect_error');
            pumpSocket.off('disconnect');
            pumpSocket.disconnect();
        };
    }, []);

    return { pumpGatewayClient: pumpSocket };
};
